import Glide from '@glidejs/glide';

export const B__BannerTestimonials = () => ({
    init: () => {
        new Glide('.glide').mount();
    }
});
